import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { useTranslation, withTranslation } from 'react-i18next';

import { Copy, Delete } from 'jbc-front/components/icons';
import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';

import { concatParamsToUrl } from 'src/utils/Http';
import * as Urls from 'src/constants/EndpointUrls';
import { PAYROLL_RULES_GROUP_PAYMENT_ON_WEEKEND_CASE_FORM } from 'src/constants/FormNames';
import { ErrorsSection } from 'src/components';
import { getDeletePayrollRulesGroupError, clearErrors } from 'src/reducers/clients/payrollRulesGroups';
import styles from './PayrollRulesGroupTableRow.scss';

const payrollRuleEditUrl = id => concatParamsToUrl(Urls.CLIENT_PAYROLL_RULES_GROUP_EDIT, { id });
const allowanceListUrl = payrollRulesGroupId => concatParamsToUrl(Urls.CLIENT_ALLOWANCES_LIST, { payrollRulesGroupId });
const copyPayrollRulesGroupUrl = id => concatParamsToUrl(Urls.COPY_CLIENT_PAYROLL_RULES_GROUP_URL, { id });

const ConfirmationBoxBodyInsideForm = ({ onConfirmClick, cancelHandler, isOpen, errors }) => {
  const { t } = useTranslation();
  return (
    <CommonModal isOpen={isOpen} hideModal={cancelHandler} ariaHideApp={false} closeOnClick>
      <CommonModal.Header hideModal={cancelHandler}>
        {t('features.PayrollRulesGroups.components.PayrollRulesGroupTableRow.confirm_of_delete')}
      </CommonModal.Header>
      <CommonModal.Body>
        <ErrorsSection errors={errors} />
        {t('features.PayrollRulesGroups.components.PayrollRulesGroupTableRow.Do_you_want_to_remove_the_salary_policy_group')}
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelHandler} className="u-mr20">
          {t('features.PayrollRulesGroups.components.PayrollRulesGroupTableRow.no')}
        </Button>
        <Button onClick={onConfirmClick} primary>
          {t('features.PayrollRulesGroups.components.PayrollRulesGroupTableRow.yes')}
        </Button>
      </CommonModal.Footer>
    </CommonModal>
  );
};

let ConfirmationBoxBody = reduxForm({
  form: PAYROLL_RULES_GROUP_PAYMENT_ON_WEEKEND_CASE_FORM
})(ConfirmationBoxBodyInsideForm);

const mapStateToProps = state => ({
  errors: getDeletePayrollRulesGroupError(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  cancelHandler: () => {
    dispatch(clearErrors());
    ownProps.onCancelClick();
  }
});

ConfirmationBoxBody = connect(mapStateToProps, mapDispatchToProps)(ConfirmationBoxBody);

class PayrollRulesGroupTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.setModalIsOpen = this.setModalIsOpen.bind(this);
    this.showConfirmBox = this.showConfirmBox.bind(this);
    this.hideConfirmBox = this.hideConfirmBox.bind(this);

    this.state = {
      isOpen: false
    };
  }

  setModalIsOpen(isOpen) {
    this.setState({
      ...this.state,
      isOpen
    });
  }

  showConfirmBox() {
    this.setModalIsOpen(true);
  }

  hideConfirmBox() {
    this.setModalIsOpen(false);
  }

  handleEvent = () => {
    const { id, onDelete } = this.props;
    onDelete(id);
  };

  render() {
    const {
      id,
      name,
      closingLabel,
      paymentLabel,
      employeesCount,
      hasConfirmedPays,
      paymentCount,
      closingLabelSecondHalf,
      paymentLabelSecondHalf
    } = this.props;

    return (
      <tr>
        <td className={styles.rule}>
          <a href={payrollRuleEditUrl(id)}>{name}</a>
        </td>
        <td>
          {/* @TODO: Temporarily hide twice monthly payment feature, will be developed later
            https://donuts-vn.atlassian.net/browse/JBC-92
         */}
          {/* {paymentCount !== 'twice' ? (
            <>
              {closingLabel} / {paymentLabel}
            </>
          ) : (
            <>
              {`${closingLabel} / ${paymentLabel}`} <br />
              {`${closingLabelSecondHalf} / ${paymentLabelSecondHalf}`}
            </>
          )} */}
          <>
            {closingLabel} / {paymentLabel}
          </>
        </td>
        <td className={styles.allownce}>
          <a href={allowanceListUrl(id)}>
            {this.props.t('features.PayrollRulesGroups.components.PayrollRulesGroupTableRow.provision_and_deduction_setting')}
          </a>
        </td>
        <td>
          <div className={styles.icons}>
            <div className={styles.noteContainer}>
              <a href={copyPayrollRulesGroupUrl(id)}>
                <Copy size={18} />
              </a>
              <div className={styles.note}>
                {this.props.t('features.PayrollRulesGroups.components.PayrollRulesGroupTableRow.Copy_and_create')}
              </div>
            </div>
            {employeesCount === 0 && !hasConfirmedPays && <Delete size={18} onClick={() => this.showConfirmBox()} />}
            <ConfirmationBoxBody isOpen={this.state.isOpen} onConfirmClick={this.handleEvent} onCancelClick={this.hideConfirmBox} />
          </div>
        </td>
      </tr>
    );
  }
}

export default withTranslation()(PayrollRulesGroupTableRow);
